<template>
    <div :class="[ 'toast-message', colorFromType ]">
        <div class="header">
            <h4 class="title">
                <span class="icon" v-if="showIcon"><i :class="iconFromType"></i></span>
                {{ title }}
            </h4>
            <button class="close-btn" @click="$emit('hideToast')" style="padding-left: 10px"><i class="fas fa-times"></i></button>
        </div>
        <div class="content">
            <p class="description" v-if="showDescription">{{ description }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "toast-message",
    props: {
        type: {
            required: false,
            type: String,
            default: "warning"
        },
        title: {
            required: true,
            type: String
        },
        description: {
            required: false,
            type: String,
            default: ""
        },
        hideIcon: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showTime: 5000
        };
    },
    mounted() {
        this.startToastTimer();
    },
    methods: {
        startToastTimer() {
            setTimeout(() => {
                this.$emit("hideToast");
            }, this.showTime);
        }
    },
    computed: {
        colorFromType() {
            switch(this.type) {
                case "error": 
                    return "red";
                case "warning": 
                    return "orange";
                case "success":
                    return "green";
                case "info": 
                    return "blue";
                default: 
                    return "";
            }
        },
        iconFromType() {
            switch(this.type) {
                case "error": 
                    return "fas fa-times-circle";
                case "warning": 
                    return "fas fa-warning";
                case "success":
                    return "fas fa-check";
                case "info": 
                    return "fas fa-info-circle";
                default: 
                    return "";
            }
        },
        showIcon() {
            return !!(this.iconFromType && this.iconFromType.length && !this.hideIcon);
        },
        showDescription() {
            return !!(this.description && this.description.length);
        }
    }
}
</script>

<style lang="scss" scoped>
.toast-message {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50px;
    right: 5px;
    padding: 15px 25px;
    max-width: 350px;
    background-color: $darker-gray;
    border-radius: 7px 0 0 7px;
    box-shadow: 0 0 10px 0 $gray;
    &.red {
        background-color: $extra-darkest-red;
    }
    &.blue {
        background-color: $dark-gray;
    }
    &.green {
        background-color: $extra-dark-green;
    }
    &.orange {
        background-color: $primary;
    }
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin: 0px 0px 7px 0px;
        .title {
            font-size: 16px;
            font-weight: 700;
            font-family: $montserrat;
            color: $white;
            margin: 0;
            .icon {
                margin: 0px 10px 0px 0px;
            }
        }
        .close-btn {
            margin: 0;
            padding: 0;
            background-color: transparent;
            color: $white;
            cursor: pointer;
            @include removeBootstrapOutline;
            @include fastestTransition;
            &:hover {
                color: $lighter-gray;
            }
        }
    }
    .content {
        display: flex;
        flex-direction: column;
        width: 100%;
        .description {
            font-family: $lato;
            font-weight: 400;
            color: $lightest-gray;
            margin: 0;
            font-size: 14px;
        }
    }
}

@media screen and (max-width: $breakpoint-sm) {
    .toast-message {
        padding: 10px 15px;
        max-width: 300px;
    }
}
</style>
